const values = [
  { img: "/assets/icons/icon-build.png", title: "Echt bouwen", text: "Breadboard, code, sensoren. Niet alleen klikken — écht maken." },
  { img: "/assets/icons/icon-group.png", title: "Max 8 per groep", text: "Persoonlijke aandacht. Niemand blijft achter, iedereen krijgt zijn moment." },
  { img: "/assets/icons/icon-price.png", title: "Meest betaalbaar", text: "~€10/uur effectief — goedkoopste per uur van alle betaalde aanbieders." },
  { img: "/assets/icons/icon-rocket.png", title: "Hyper-actuele tools", text: "Arduino, Scratch, Python en 3D print — echte tools die meegroeien met het kind." },
];

export function Values() {
  return (
    <section className="bg-alt" id="waarom">
      <div className="container">
        <div className="section-head">
          <span className="section-tag">Waarom Makers Hub?</span>
          <h2>Hands-on leren dat echt blijft plakken</h2>
          <p>
            Geen boekentheorie. Deelnemers bouwen vanaf minuut één aan iets tastbaars — en
            snappen tegelijk hoe het werkt.
          </p>
        </div>
        <div className="grid-4">
          {values.map((v) => (
            <div className="card" key={v.title}>
              <img src={v.img} alt={v.title} className="card-img" />
              <h3>{v.title}</h3>
              <p>{v.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
